// extracted by mini-css-extract-plugin
module.exports = {"icon":"_K58OhoI5"};